import { render, staticRenderFns } from "./ExpertInvitesTable.vue?vue&type=template&id=5bc3c453&scoped=true&lang=pug"
import script from "./ExpertInvitesTable.vue?vue&type=script&lang=ts"
export * from "./ExpertInvitesTable.vue?vue&type=script&lang=ts"
import style0 from "./ExpertInvitesTable.vue?vue&type=style&index=0&id=5bc3c453&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc3c453",
  null
  
)

/* custom blocks */
import block0 from "./ExpertInvitesTable.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FComponents%2FTable%2FExpertInvitesTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports